export const SET_PAYMENT_COLLECTION = 'PAYMENT/SET_PAYMENT_COLLECTION';
